import inbanner from '../../assets/img/ofrexcser.jpg';
import ofrcapbld from '../../assets/img/ofrcapbld.jpg';
import InnerBanner from './InnerBanner';
import { Helmet } from 'react-helmet-async';

const Offerings = () => {
    return (
        <>
            <div className="page page_home">
                <Helmet>
                    <title>Offerings</title>
                    <meta name='description' content="Precision sourcing for the perfect fit. We focus on identifying candidates who align seamlessly with your organization's culture and objectives, ensuring a match that lasts." />
                    <meta name="keywords"
                        content="FirstResource, firstresource, first resource, recruitment, recruiters, talent acquisition, hiring, staffing, job placement, workforce solutions, recruitment agency, employment services, candidate sourcing, recruitment solutions, talent management, HR services, recruitment consultancy" />
                </Helmet>
                <InnerBanner />
                <div className="section intalaq">
                    <div className="container intalaqin">
                        <div className="row">
                            <div className="col-12">
                                <h2 className="title mb-3 mb-lg-5 fwbold"><span className='text-dark text-opacity-25'>Talent</span> <span className='text-body-tertiary'>Acquisition</span></h2>
                            </div>
                        </div>
                        <div className="row justify-content-end">
                            <div className="col-12 col-lg-9">
                                <div className="px-3 ps-lg-5">
                                    <p className="fs-3 fwmed text-body-tertiary ps-0 ps-lg-5 ms-0 ms-lg-5">
                                        Precision sourcing for the perfect fit. We focus on identifying candidates who align seamlessly with your organization's culture and objectives, ensuring a match that lasts.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section inexcser bg-body-secondary">
                    <div className="backstage">
                        <div className="cover">
                            <img src={inbanner} alt="employee" />
                        </div>
                    </div>
                    <div className="container inexcserin px-4 px-lg-0">
                        <div className="inexcser_content">
                            <div className="title_holder">
                                <div className="left">
                                    <h2 className="title text-white text-lg-body-tertiary">Executive</h2>
                                </div>
                                <div className="right">
                                    <h2 className="title text-dark text-lg-white">Search</h2>
                                </div>
                            </div>
                            <div className="desc">
                                <p className="fs-4 fwmed lh-lg">
                                    Finding leaders who inspire. By leveraging our deep industry insights and extensive network, we connect you with exceptional executive talent that aligns perfectly with your vision. Our personalized approach ensures that we find leaders who not only meet your needs but also share your passion and drive for success.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section inrpo">
                    <div className="container px-4 px-lg-0">
                        <div className="row">
                            <div className="col-12 col-lg-8">
                                <h3 className="display-2 mb-3 mb-lg-5 fwlight">Recruitment<br /> Process Outsourcing</h3>
                            </div>
                        </div>
                        <div className="row justify-content-end">
                            <div className="col-12 col-lg-9">
                                <p className="fs-3 fwmed text-body-tertiary">
                                    Your hiring, streamlined. Let us take the reins of your recruitment process. We handle everything from sourcing to onboarding, giving you more time to focus on what you do best
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section incapbuild">
                    <div className="backstage">
                        <div className="cover">
                            <img src={ofrcapbld} alt="employee" />
                        </div>
                    </div>
                    <div className=" incapbuildin">
                        <div className="container incapbuild_content px-4 px-lg-0">
                            <div className='row'>
                                <div className="col-12">
                                    <h2 className="title fwbold text-white">Capacity Building</h2>
                                </div>
                            </div>
                            <div className='row justify-content-end'>
                                <div className="col-12 col-lg-8">
                                    <div className="desc text-white">
                                        <p className="fs-2 fwbold ">
                                            We deliver tailored training and capacity-building solutions to equip teams with modern skills for driving innovation and impactful results.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default Offerings;